/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EngineType } from './EngineType';
import {
    EngineTypeFromJSON,
    EngineTypeFromJSONTyped,
    EngineTypeToJSON,
    EngineTypeToJSONTyped,
} from './EngineType';
import type { ProcurementType } from './ProcurementType';
import {
    ProcurementTypeFromJSON,
    ProcurementTypeFromJSONTyped,
    ProcurementTypeToJSON,
    ProcurementTypeToJSONTyped,
} from './ProcurementType';

/**
 * 
 * @export
 * @interface VehicleCreate
 */
export interface VehicleCreate {
    /**
     * Company that manufactures this vehicle. Between 1 and 100 characters.
     * @type {string}
     * @memberof VehicleCreate
     */
    manufacturer?: string | null;
    /**
     * Generic description of this vehicle type (e.g. make or model). Between 1 and 70 characters.
     * @type {string}
     * @memberof VehicleCreate
     */
    model?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleCreate
     */
    vehicleTypeId?: string | null;
    /**
     * The vehicle's serial number. This is expected to be unique
     * @type {string}
     * @memberof VehicleCreate
     */
    serialNumber: string;
    /**
     * The date at which this vehicle has been built.
     * @type {number}
     * @memberof VehicleCreate
     */
    manufactureYear?: number | null;
    /**
     * The department this vehicle is assigned to.
     * @type {string}
     * @memberof VehicleCreate
     */
    departmentId?: string | null;
    /**
     * The Shock profile that's assigned to this vehicle.
     * @type {string}
     * @memberof VehicleCreate
     */
    shockProfileId?: string | null;
    /**
     * This is a placeholder for now, we don't do anything with it yet.
     * @type {string}
     * @memberof VehicleCreate
     */
    phoneImei?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleCreate
     */
    preOpsChecklistId?: string | null;
    /**
     * Whether the vehicle is leased, rented or actually belongs to the company.
     * @type {ProcurementType}
     * @memberof VehicleCreate
     */
    procurementType?: ProcurementType | null;
    /**
     * In case the vehicle is purchased, this is the time of the purchase.
     * @type {Date}
     * @memberof VehicleCreate
     */
    purchaseDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleCreate
     */
    purchaseCost?: number | null;
    /**
     * In case the vehicle is leased or rented, this is the start of the contract time.
     * @type {Date}
     * @memberof VehicleCreate
     */
    contractTermStart?: Date | null;
    /**
     * In case the vehicle is leased or rented, this is the end of the contract time.
     * @type {Date}
     * @memberof VehicleCreate
     */
    contractTermEnd?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleCreate
     */
    monthlyCost?: number | null;
    /**
     * This vehicle's operating hours at the point of procurement.
     * @type {number}
     * @memberof VehicleCreate
     */
    initialOperatingHours: number;
    /**
     * The fleet user should be automatically logged out, if the vehicle is idle for the specified amount of minutes.
     * @type {number}
     * @memberof VehicleCreate
     */
    idleAutoLogoutAfter?: number | null;
    /**
     * The regular interval at which this vehicle should be maintained.
     * @type {number}
     * @memberof VehicleCreate
     */
    maintenanceInterval: number;
    /**
     * The threshold in hours at which the users should see a notification that maintenance is due.
     * @type {number}
     * @memberof VehicleCreate
     */
    maintenanceNotificationAt?: number | null;
    /**
     * This boolean decides, whether normal fleet users won't be able drive the vehicle, once maintenance is scheduled.
     * @type {boolean}
     * @memberof VehicleCreate
     */
    maintenanceLockdown: boolean;
    /**
     * This boolean decides, whether users have to complete the checklist to start driving.
     * @type {boolean}
     * @memberof VehicleCreate
     */
    checklistOverride: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleCreate
     */
    weeklyDriveGoalHours?: number | null;
    /**
     * The vehicle engine type
     * @type {EngineType}
     * @memberof VehicleCreate
     */
    engineType: EngineType;
    /**
     * This is for detecting motion on electric vehicles.
     * 
     * Only super admin users are allowed to set this to anything other than the default of 100.
     * @type {number}
     * @memberof VehicleCreate
     */
    magneticFieldThreshold: number;
    /**
     * This is part of a hysteresis trigger for detecting motion on ICE vehicles.
     * @type {number}
     * @memberof VehicleCreate
     */
    motionStartThresholdMv: number;
    /**
     * This is part of a hysteresis trigger for detecting motion on ICE vehicles.
     * @type {number}
     * @memberof VehicleCreate
     */
    motionStopThresholdMv: number;
    /**
     * The sensed voltage needs to be above the start threshold for this amount of time before we detect the vehicle as moving.
     * 
     * This is part of a hysteresis trigger for detecting motion on ICE vehicles.
     * 
     * ## Note
     * 
     * This should really be a `chrono::Duration` but the `schemars` version used by `okapi` doesn't have support for `chrono::Duration`.
     * @type {number}
     * @memberof VehicleCreate
     */
    motionStartDelayMs: number;
    /**
     * The sensed voltage needs to be below the stop threshold for this amount of time before we detect the vehicle as stopped.
     * 
     * This is part of a hysteresis trigger for detecting motion on ICE vehicles.
     * 
     * ## Note
     * 
     * This should really be a `chrono::Duration` but the `schemars` version used by `okapi` doesn't have support for `chrono::Duration`.
     * @type {number}
     * @memberof VehicleCreate
     */
    motionStopDelayMs: number;
    /**
     * Speaker volume for voice notifications, between 0.0 and 1.0.
     * @type {number}
     * @memberof VehicleCreate
     */
    speakerVolume?: number | null;
}



/**
 * Check if a given object implements the VehicleCreate interface.
 */
export function instanceOfVehicleCreate(value: object): value is VehicleCreate {
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('initialOperatingHours' in value) || value['initialOperatingHours'] === undefined) return false;
    if (!('maintenanceInterval' in value) || value['maintenanceInterval'] === undefined) return false;
    if (!('maintenanceLockdown' in value) || value['maintenanceLockdown'] === undefined) return false;
    if (!('checklistOverride' in value) || value['checklistOverride'] === undefined) return false;
    if (!('engineType' in value) || value['engineType'] === undefined) return false;
    if (!('magneticFieldThreshold' in value) || value['magneticFieldThreshold'] === undefined) return false;
    if (!('motionStartThresholdMv' in value) || value['motionStartThresholdMv'] === undefined) return false;
    if (!('motionStopThresholdMv' in value) || value['motionStopThresholdMv'] === undefined) return false;
    if (!('motionStartDelayMs' in value) || value['motionStartDelayMs'] === undefined) return false;
    if (!('motionStopDelayMs' in value) || value['motionStopDelayMs'] === undefined) return false;
    return true;
}

export function VehicleCreateFromJSON(json: any): VehicleCreate {
    return VehicleCreateFromJSONTyped(json, false);
}

export function VehicleCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'manufacturer': json['manufacturer'] == null ? undefined : json['manufacturer'],
        'model': json['model'] == null ? undefined : json['model'],
        'vehicleTypeId': json['vehicleTypeId'] == null ? undefined : json['vehicleTypeId'],
        'serialNumber': json['serialNumber'],
        'manufactureYear': json['manufactureYear'] == null ? undefined : json['manufactureYear'],
        'departmentId': json['departmentId'] == null ? undefined : json['departmentId'],
        'shockProfileId': json['shockProfileId'] == null ? undefined : json['shockProfileId'],
        'phoneImei': json['phoneImei'] == null ? undefined : json['phoneImei'],
        'preOpsChecklistId': json['preOpsChecklistId'] == null ? undefined : json['preOpsChecklistId'],
        'procurementType': json['procurementType'] == null ? undefined : ProcurementTypeFromJSON(json['procurementType']),
        'purchaseDate': json['purchaseDate'] == null ? undefined : (new Date(json['purchaseDate'])),
        'purchaseCost': json['purchaseCost'] == null ? undefined : json['purchaseCost'],
        'contractTermStart': json['contractTermStart'] == null ? undefined : (new Date(json['contractTermStart'])),
        'contractTermEnd': json['contractTermEnd'] == null ? undefined : (new Date(json['contractTermEnd'])),
        'monthlyCost': json['monthlyCost'] == null ? undefined : json['monthlyCost'],
        'initialOperatingHours': json['initialOperatingHours'],
        'idleAutoLogoutAfter': json['idleAutoLogoutAfter'] == null ? undefined : json['idleAutoLogoutAfter'],
        'maintenanceInterval': json['maintenanceInterval'],
        'maintenanceNotificationAt': json['maintenanceNotificationAt'] == null ? undefined : json['maintenanceNotificationAt'],
        'maintenanceLockdown': json['maintenanceLockdown'],
        'checklistOverride': json['checklistOverride'],
        'weeklyDriveGoalHours': json['weeklyDriveGoalHours'] == null ? undefined : json['weeklyDriveGoalHours'],
        'engineType': EngineTypeFromJSON(json['engineType']),
        'magneticFieldThreshold': json['magneticFieldThreshold'],
        'motionStartThresholdMv': json['motionStartThresholdMv'],
        'motionStopThresholdMv': json['motionStopThresholdMv'],
        'motionStartDelayMs': json['motionStartDelayMs'],
        'motionStopDelayMs': json['motionStopDelayMs'],
        'speakerVolume': json['speakerVolume'] == null ? undefined : json['speakerVolume'],
    };
}

export function VehicleCreateToJSON(json: any): VehicleCreate {
    return VehicleCreateToJSONTyped(json, false);
}

export function VehicleCreateToJSONTyped(value?: VehicleCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'manufacturer': value['manufacturer'],
        'model': value['model'],
        'vehicleTypeId': value['vehicleTypeId'],
        'serialNumber': value['serialNumber'],
        'manufactureYear': value['manufactureYear'],
        'departmentId': value['departmentId'],
        'shockProfileId': value['shockProfileId'],
        'phoneImei': value['phoneImei'],
        'preOpsChecklistId': value['preOpsChecklistId'],
        'procurementType': ProcurementTypeToJSON(value['procurementType']),
        'purchaseDate': value['purchaseDate'] == null ? value['purchaseDate'] : value['purchaseDate'].toISOString(),
        'purchaseCost': value['purchaseCost'],
        'contractTermStart': value['contractTermStart'] == null ? value['contractTermStart'] : value['contractTermStart'].toISOString(),
        'contractTermEnd': value['contractTermEnd'] == null ? value['contractTermEnd'] : value['contractTermEnd'].toISOString(),
        'monthlyCost': value['monthlyCost'],
        'initialOperatingHours': value['initialOperatingHours'],
        'idleAutoLogoutAfter': value['idleAutoLogoutAfter'],
        'maintenanceInterval': value['maintenanceInterval'],
        'maintenanceNotificationAt': value['maintenanceNotificationAt'],
        'maintenanceLockdown': value['maintenanceLockdown'],
        'checklistOverride': value['checklistOverride'],
        'weeklyDriveGoalHours': value['weeklyDriveGoalHours'],
        'engineType': EngineTypeToJSON(value['engineType']),
        'magneticFieldThreshold': value['magneticFieldThreshold'],
        'motionStartThresholdMv': value['motionStartThresholdMv'],
        'motionStopThresholdMv': value['motionStopThresholdMv'],
        'motionStartDelayMs': value['motionStartDelayMs'],
        'motionStopDelayMs': value['motionStopDelayMs'],
        'speakerVolume': value['speakerVolume'],
    };
}

